import React, { useCallback } from 'react'
import styled from 'styled-components'
import capitalize from 'lodash.capitalize'
import { useHistory } from 'react-router-dom'

import { colors } from 'helpers/colors'
import Flex from 'components/reusable/flex'
import Text from 'components/reusable/text'
import Indent from 'components/reusable/indent'
import Link from 'components/reusable/link'
import { routes } from 'helpers/router_helper'
import Button from 'components/reusable/button'
import AuthHelper from 'helpers/auth_helper'
import Avatar from 'components/complex/user/avatar'
import ScAnalytics from 'classes/sc_analytics'
import { useConversationSelector } from 'store/selectors'
import useOtherParticipant from 'hooks/chat/use_other_participant'

const SignUpGuestMessageSuccess = ({ onClose }) => {
  const history = useHistory()
  const conversation = useConversationSelector().details
  const participant = useOtherParticipant(conversation?.participants)
  const participantName = participant ? `to ${capitalize(participant.first_name)}` : ''

  const handlePostJob = useCallback(() => {
    ScAnalytics.sendProjectInitFunnel(false, 'Guest Message Success', 'Guest Message Modal')
    history.push(routes.createProject.redirectUrl())
    onClose()
  }, [])

  return (
    <Wrapper dir="column">
      <Link onClick={onClose} to={routes.user.me.albums.redirectUrl()}>
        <Avatar user={AuthHelper.currentUser()} width={window.screen.width / 3} />
      </Link>

      <Indent top={24} />
      <Text textAlign="center" size={20} weight={500}>
        Congratulations, {capitalize(AuthHelper.logged_in_firstName)}!
      </Text>
      <Indent top={16} />
      <Text textAlign="center" size={14}>
        You’ve been signed up successfully. Your message has been delivered {participantName}.&nbsp;
        <Link onClick={onClose} size={14}>
          Return to Chat
        </Link>
      </Text>
      <Indent top={40} />
      <Button width="100%" onClick={handlePostJob} height={40} type="primary">
        Post a Public Job
      </Button>
      <Indent top={12} />
      <Text size={14}>
        Need assistance?&nbsp;
        <Link onClick={onClose} size={14} to={routes.faq.redirectUrl()}>
          Contact Us
        </Link>
      </Text>
    </Wrapper>
  )
}

const Wrapper = styled(Flex)`
  max-width: 744px;
  border-radius: 0;
  background-color: ${colors.light};
  height: 100vh;
  width: 100vw;
  padding: 24px 16px;
`

export default SignUpGuestMessageSuccess
